const url = require('url')

let urls = null
let web_url = 'http://localhost:8080'
let api_url = 'http://localhost:3000/api/'
//let static_url = 'http://localhost:3000/static/'
let static_url = 'https://images.mdtalk.io/node/test/static/'
let io_url = 'http://localhost:8001'
let s3_url = 'https://images.mdtalk.io/node/test/' //의사 웹에서 올리는 s3 이미지 업로드 폴더
let s3_app_url = 'https://images.mdtalk.io/node/test/' //의사 웹에서 올리는 s3 이미지 업로드 폴더(기본에는 api_url로 썼으나 axios url과 겹쳐 분리 한다.)
let python_api_url = 'https://apitest.mdtalk.io/';  // 파이썬 api url
let python_api_token = '26c42293dd1fd5ed01320646e094196a827393f8';  // 파이썬 api 
let pg_web_url = 'https://usertest.mdtalk.io/'

function set_urls (api_url, static_url, web_url, io_url, s3_url, s3_app_url, python_api_url, python_api_token) {
  // resolve에서 앞에 주소의 기존의 path를 유지할려면 꼭 ending slash
  urls = { // JETBRAINS 툴에서 code completion 지원을 위해서 일부러 할당한다.
    API: api_url, // BASE_API_URL, SERVER_API.DEV or SERVER_API.PROD or SERVER_API
    WEB: web_url,
    STATIC: static_url, // STATIC_URL,
    IO: io_url,
    IMG_DR_LIC: url.resolve(static_url, 'dr_web/dr_lic/'), // IMG_LICENSE_URL
    IMG_DR: url.resolve(static_url, 'dr_web/dr/'), // IMG_DR_URL
    IMG_USER: url.resolve(static_url, 'dr_web/user/'), // IMG_USER_URL
    IMG_HOSP: url.resolve(static_url, 'dr_web/hosp/'), // IMG_HOSP_URL
    IMG_APP: url.resolve(static_url, 'apps/'),
    MSG_ATTACH: url.resolve(static_url, 'dr_web/msg/'),
    IMG_BANNER: url.resolve(static_url, 'banner/'), // IMG_BANNER_URL
    IMP_CALLBACK: url.resolve(api_url, 'cb/imp'), // PAYMENT.IMP_REDIRECT_URL
    PAY_ENTRY: url.resolve(web_url, '/payment'), // PAYMENT.URL_ENTRY
    PAY_SUCCESS: url.resolve(web_url, '/payment/complete'), // PAYMENT.URL_SUCCESS
    PAY_FAILED: url.resolve(web_url, '/payment/error'), // PAYMENT.URL_FAIL
    S3: s3_url,
    S3_APP: s3_app_url,
    API_PY: python_api_url,
    API_PY_TOKEN: python_api_token,
  }
}

process.env.UV_THREADPOOL_SIZE = 10;
// console.log('urls.js process.env.UV_THREADPOOL_SIZE : ', process.env.UV_THREADPOOL_SIZE)
// console.log('urls.js process.env.NODE_ENV : ', process.env.NODE_ENV);

if (process.env.NODE_ENV === 'production') { // Live 서버
  web_url = 'https://dr.mdtalk.io'
  api_url = 'https://drapi.mdtalk.io/v2/'
  static_url = 'https://images.mdtalk.io/node/prod/static/'
  io_url = 'https://mdsqr.iland.co.kr:8001'
  s3_url = 'https://images.mdtalk.io/node/prod/'
  s3_app_url = 'https://images.mdtalk.io/node/prod/'
  python_api_url = 'https://api-v2.mdtalk.io/'
  python_api_token = '801a023f4ede1819f7820399ba53e60a3d387048'
  set_urls(api_url, static_url, web_url, io_url, s3_url, s3_app_url, python_api_url, python_api_token, )

} else if (process.env.NODE_ENV === 'testing') { // 안씀
  web_url = 'https://drtest.mdtalk.io'
  api_url = 'https://drapitest.mdtalk.io'
  static_url = 'https://images.mdtalk.io/node/test/static/'
  io_url = 'https://drapitest.mdtalk.io:8001'
  s3_url = 'https://images.mdtalk.io/node/test/'
  s3_app_url = 'https://images.mdtalk.io/node/test/'
  python_api_url = 'https://api-v2.mdtalk.io/'
  python_api_token = '801a023f4ede1819f7820399ba53e60a3d387048'
  set_urls(api_url, static_url, web_url, io_url, s3_url, s3_app_url, python_api_url, python_api_token, ) 

} else if (process.env.NODE_ENV === 'home_test') { // 안씀
  web_url = 'http://192.168.0.6:3000'
  api_url = 'http://192.168.0.6:3000/api/'
  static_url = 'http://192.168.0.6:3000/static/'
  io_url = 'http://192.168.0.6:8001'
  s3_url = 'https://images.mdtalk.io/node/test/'
  s3_app_url = 'https://images.mdtalk.io/node/test/'
  python_api_url = 'https://api-v2.mdtalk.io/'
  python_api_token = '801a023f4ede1819f7820399ba53e60a3d387048'
  set_urls(api_url, static_url, web_url, io_url, s3_url, s3_app_url, python_api_url, python_api_token, ) 

} else if (process.env.NODE_ENV === 'development') { // 개발 서버가 이거로 켜짐
  web_url = 'https://drtest.mdtalk.io'
  api_url = 'https://drapitest.mdtalk.io'
  static_url = 'https://images.mdtalk.io/node/test/static/'
  io_url = 'https://drapitest.mdtalk.io:8001'
  s3_url = 'https://images.mdtalk.io/node/test/'
  s3_app_url = 'https://images.mdtalk.io/node/test/'
  python_api_url = 'https://api-v2.mdtalk.io/'
  python_api_token = '801a023f4ede1819f7820399ba53e60a3d387048'
  set_urls(api_url, static_url, web_url, io_url, s3_url, s3_app_url, python_api_url, python_api_token, )

} else if (process.env.NODE_ENV === 'local') { // Local이 이거로 켜짐
  web_url = 'http://localhost:3000'
  api_url = 'http://localhost:3000/api/'
  static_url = 'https://images.mdtalk.io/node/test/static/'
  io_url = 'http://localhost:8001'
  s3_url = 'https://images.mdtalk.io/node/test/'
  s3_app_url = 'https://images.mdtalk.io/node/test/'
  python_api_url = 'https://api-v2.mdtalk.io/'
  python_api_token = '801a023f4ede1819f7820399ba53e60a3d387048'
  set_urls(api_url, static_url, web_url, io_url, s3_url, s3_app_url, python_api_url, python_api_token, )

} else {
  web_url = 'https://drtest.mdtalk.io'
  api_url = 'https://drapitest.mdtalk.io'
  static_url = 'https://images.mdtalk.io/node/test/static/'
  io_url = 'https://drapitest.mdtalk.io:8001'
  s3_url = 'https://images.mdtalk.io/node/test/'
  s3_app_url = 'https://images.mdtalk.io/node/test/'
  python_api_url = 'https://api-v2.mdtalk.io/'
  python_api_token = '801a023f4ede1819f7820399ba53e60a3d387048'
  set_urls(api_url, static_url, web_url, io_url, s3_url, s3_app_url, python_api_url, python_api_token, ) 
}

module.exports = urls
